import styled from 'styled-components'

import { Typography } from '@/components/ui/typography'

import type { WeekScheduleVariant } from './week-schedule.types'

export const Section = styled.div<{ $variant: WeekScheduleVariant }>(({ theme, $variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $variant === 'maintenance' ? theme.space['8'] : theme.space['16'],
}))

export const DayButtons = styled.div(({ theme }) => ({
  '> button': {
    flexShrink: 0,
    height: theme.space['40'],
    overflow: 'hidden',
    padding: 0,
    width: theme.space['40'],
  },
  '> button [data-button-children-wrapper]': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['8'],
}))

export const WeekHours = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const DayHoursRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['16'],
}))

export const DayName = styled.div<{ $variant: WeekScheduleVariant }>(({ $variant }) => ({
  flexShrink: 0,
  width: $variant === 'maintenance' ? '6.4rem' : '3rem',
}))

export const DayLabel = styled(Typography)(() => ({
  minWidth: '2.1rem',
}))

export const TimeSelectors = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  gap: theme.space['16'],
}))

export const TimeSeparator = styled(Typography)(() => ({
  flexShrink: 0,
}))

export const ControlWrapper = styled.div<{ $stretch?: boolean }>(({ $stretch }) =>
  $stretch ? { flex: 1, minWidth: 0 } : { width: '15.1rem' },
)
